import React from 'react';
import { useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { OmCalculatorResult, OmIcon } from '@om/component-library-react'

import {
    getInvestmentGrowth,
    getInflation,
    getFundPerformance,
    getCalculationDate,
} from '@om/redux/selectors/pastPerformanceCalculator/pastPerformanceCalculator';

import OmButton from '../forms/OmButton';

const PastPerformanceResultCard = () => {

    const {
        investmentGrowth,
        inflation,
        returnOfInvestment,
        investmentGrowthCalculationDate,
    } = useSelector(
        createStructuredSelector({
            investmentGrowth: getInvestmentGrowth,
            inflation: getInflation,
            returnOfInvestment : getFundPerformance,
            investmentGrowthCalculationDate : getCalculationDate,
        })
    );

    return (
        <OmCalculatorResult restrictMobileWidth>
            <div slot="row-1-col-1">
                <h6 className="small-margin-bottom no-top-margin">Inflation over the same period(%)</h6>
                <h6 className="no-bottom-margin no-top-margin">Return of Investment(%)</h6>
            </div>

            <div slot="row-1-col-2">
                <h6 className="small-margin-bottom no-top-margin right"><strong>{ inflation }%</strong></h6>
                <h6 className="no-bottom-margin no-top-margin right"><strong>{ returnOfInvestment }%</strong></h6>
            </div>

            <h6 slot="end-heading"><strong>Need more information?</strong></h6>

            <p slot="end-text">We’ve created a range of unit trust investments for every investor at every stage of life.</p>

            <OmIcon slot="row-2-icon" iconName="vector_flower" />

            <div slot="row-2-col-1">
                <p className="no-bottom-margin no-top-margin">Investment Growth as at { investmentGrowthCalculationDate }</p>
                <h5 className="no-bottom-margin no-top-margin"><strong>{ investmentGrowth }</strong></h5>
            </div>

            <OmButton
                slot="end-button"
                text="INVEST NOW"
                type="primary"
                size="small"
                url="/all-products"
                actionType="url"
                openTab={true}
            />
        </OmCalculatorResult>
    )
}

export default PastPerformanceResultCard;

